import { render, staticRenderFns } from "./bimTextarea.vue?vue&type=template&id=92645a6a&scoped=true&"
import script from "./bimTextarea.vue?vue&type=script&lang=js&"
export * from "./bimTextarea.vue?vue&type=script&lang=js&"
import style0 from "./bimTextarea.vue?vue&type=style&index=0&id=92645a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92645a6a",
  null
  
)

export default component.exports